<!-- @format -->

<ng-container *transloco="let t">
  <sis-contextual-notification [variant]="'danger'">
    <p>{{ t("PLAN_EDIT.SELECTION_MODAL.RULE_ERROR_SUMMARY.HELP_TEXT") }}</p>
    <ul>
      @for (ruleErrorStateObject of ruleErrorStates; track trackByRuleLocalId($index, ruleErrorStateObject)) {
        @for (error of ruleErrorStateObject.errors; track trackByErrorId($index, error)) {
          <li>
            @if (error.errorType === "LESS_SELECTIONS_REQUIRED") {
              <sis-button [link]="true" (clicked)="this.errorClick.emit([ruleErrorStateObject, error])">
                {{
                  t("PLAN_EDIT.SELECTION_MODAL.RULE_ERROR_SUMMARY.RULE_ERRORS.LESS_SELECTIONS_REQUIRED", {
                    groupName: ruleErrorStateObject.ruleDisplayName,
                  })
                }}
              </sis-button>
            }
          </li>
        }
      }
    </ul>
  </sis-contextual-notification>
</ng-container>
